import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';

export default function Eliminator537Page() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <div className="bg-[#f5f5f5] py-4">
        <div className="container mx-auto px-4">
          <h5 className="text-sm text-[#333333]">
            <Link to="/" className="hover:underline">Home</Link> / 537 ELIMINATOR
          </h5>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Images */}
          <div>
            <div className="mb-4">
              <img 
                              src="/images/537_UPCLOSE_01-1024x575.jpg" 
                alt="537 Eliminator" 
                className="w-full rounded-lg"
              />
            </div>
            
              
              

            
          </div>

          {/* Right Column - Product Info */}
          <div>
            
            <h1 className="text-4xl font-bold text-[#333333] mb-4">537 ELIMINATOR</h1>
            <h4 className="text-xl text-[#666666] mb-2">Model: 537000</h4>
            <h4 className="text-xl text-[#666666] mb-6">Weight: 848 lbs</h4>

            <div className="prose max-w-none mb-8">
              <h2 className="text-2xl font-bold text-[#333333] mb-4">Ultimate Tree Puller for Skid Steers</h2>
              <p className="text-[#666666] mb-4">
                The 537 ELIMINATOR is the most advanced and powerful tree puller for skid steers on the market. Designed for professionals and landowners who demand maximum performance, this heavy-duty attachment removes entire trees—roots and all—with unmatched efficiency and precision.
              </p>
              <p className="text-[#666666] mb-4">
                Built to handle the toughest jobs, the 537 ELIMINATOR features extended blades, an oversized root ripper, and a built-in saw capable of cutting trees up to 12 inches in diameter. It's the ultimate solution for land clearing, brush removal, and tree extraction.
              </p>
              <p className="text-[#666666] mb-4">
                With sharp, serrated jaws for a secure grip and 8" wide spade points for deep soil penetration, this tree puller for skid steers delivers professional-grade results every time. The open-tip design also makes it perfect for pulling posts, stakes, and moving heavy rocks.
              </p>
              <p className="text-[#666666]">
                If you need the best tree puller for skid steers that combines power, versatility, and durability, the 537 ELIMINATOR is your answer!
              </p>
            </div>

            <hr className="my-8 border-[#e5e5e5]" />

            {/* Features Accordion */}
            <div className="mb-8">
              <details className="group" open>
                <summary className="flex justify-between items-center cursor-pointer list-none py-4 border-b border-[#e5e5e5]">
                  <span className="text-lg font-bold text-[#333333]">FEATURES</span>
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="py-4">
                  <ul className="list-disc pl-6 space-y-2 text-[#666666]">
                    <li>Extended blade length by 18" for maximum root access</li>
                    <li>Triple-sized root ripper for superior cutting performance</li>
                    <li>36" jaw opening for large trees</li>
                    <li>Reversed 8" wide spade points for enhanced soil penetration</li>
                    <li>Open blade spacing allows dirt and debris to pass through</li>
                    <li>Hydraulic hose holder for better hose management (TAMEit not included)</li>
                    <li>Open-tip design minimizes damage when pulling "T" posts</li>
                    <li>Extra-long 90° blade teeth for maximum grip and stability</li>
                    <li>Built-in saw feature cuts trees up to 12" in diameter from one side</li>
                  </ul>
                </div>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="space-y-4">
              <a 
                href="/contact" 
                className="block w-full bg-[#d4af37] text-white text-center py-3 px-6 font-bold hover:bg-[#c19b2a] transition-colors"
              >
                Call Us Now
              </a>
              <div className="grid grid-cols-2 gap-4">
                
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-16 bg-[#f5f5f5] p-8 rounded-lg">
          <h3 className="text-2xl font-bold text-[#333333] mb-6">Frequently Asked Questions</h3>
          <div className="space-y-4">
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: What makes the 537 ELIMINATOR the best tree puller for skid steers?</p>
              <p className="text-[#666666]">A: The 537 ELIMINATOR offers the most advanced features available, including 18" extended blades, a triple-sized root ripper, and a built-in saw that cuts trees up to 12 inches in diameter. It's designed for maximum power and versatility, making it the top choice for professional land clearing.</p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: How does the 537 compare to other tree pullers?</p>
              <p className="text-[#666666]">A: The 537 ELIMINATOR is our most powerful model, featuring the longest blade extension (18"), the largest root ripper, and the widest jaw opening (36"). It's built for the toughest jobs and largest trees, offering capabilities that standard tree pullers simply can't match.</p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: Is the 537 ELIMINATOR compatible with all skid steers?</p>
              <p className="text-[#666666]">A: Yes, the 537 is designed to work with most skid steers using a universal quick attach system. It's a professional-grade tree puller for skid steers that integrates seamlessly with your existing equipment.</p>
            </div>
          </div>
        </div>

       

        {/* Disclaimer */}
        <div className="mt-12 bg-[#f5f5f5] p-8 rounded-lg text-center">
          <h3 className="text-xl font-bold text-[#333333] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

      
    </div>
  );
}